import { Button } from "./ui/button";

export const EmptyState = ({ icon: Icon, title, description, actionLabel, onAction }) => (
  <div data-testid="empty-state" className="flex flex-col items-center justify-center py-20 px-6 text-center">
    {Icon && <Icon className="w-12 h-12 text-slate-300 mb-4" strokeWidth={1.5} />}
    <h3 className="font-heading font-bold tracking-tighter text-lg text-slate-900">{title}</h3>
    <p className="text-sm text-slate-500 mt-1 max-w-sm">{description}</p>
    {actionLabel && (
      <Button data-testid="empty-state-action" onClick={onAction} className="mt-6 rounded-full bg-slate-900 hover:bg-slate-800">
        {actionLabel}
      </Button>
    )}
  </div>
);
